import { SET_SELECTED_USER_PROFILE } from "../constants/action-types-admin";

//LogRocket

export const setSelectedUserProfile = (result) => ({
    type: SET_SELECTED_USER_PROFILE,
    payload: result,
});
